<template>
<v-select ref="products" v-model="internalValue" @focus="onFocus" :loading="loading" :items="items" item-text="title" item-value="product" v-bind="$attrs" v-on="$listeners" :rules="rules" no-data-text="اطلاعاتی موجود نیست..." />
</template>

<script>
import vueAxios from '../functions/vueAxios'

export default {
  name: 'MyProductsUnits',
  props: {
    value: {
      required: true
    },
    autoFocus: {
      type: Boolean,
      default: false
    },
    rules: {
      type: Array,
      default: () => [
        v => !!v || 'فیلد الزامی',
      ],
    },
  },
  data() {
    return {
      loading: false,
      items: [],
    }
  },
  computed: {
    internalValue: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      },
    },
  },
  methods: {
    buildProductItems(data) {
      return data.flatMap(item => {
        const base = [{
          product: {
            _id: item._id,
            n: 1
          },
          title: `${item.title} (${item.unit1})`,
        }]
        if (item.unit2) {
          base.push({
            product: {
              _id: item._id,
              n: item.n
            },
            title: `${item.title} (${item.unit2})`,
          })
        }
        return base
      })
    },
    async retrieveData() {
      this.loading = true
      try {
        const res = await vueAxios.get('/products/name')
        if (res) {
          this.items = this.buildProductItems(res)
        }
      } catch (e) {
        console.error(e)
      } finally {
        this.loading = false
      }
    },
    onFocus() {
      if (!this.internalValue && this.items.length) {
        this.internalValue = this.items[0].product
      }
    },
  },
  async created() {
    await this.retrieveData()
  },
  mounted() {
    if (this.autoFocus) {
      this.$refs.products.focus()
    }
  },
}
</script>
